import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { LOGO_URL } from "@/data/services";
import { TID } from "@/constants/testIds/site";

const links = [
  { href: "#services", label: "Services", tid: TID.nav.linkServices },
  { href: "#pricing", label: "Tarifs", tid: TID.nav.linkPricing },
  { href: "#process", label: "Processus", tid: TID.nav.linkProcess },
  { href: "#contact", label: "Contact", tid: TID.nav.linkContact },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "backdrop-blur-xl bg-black/60 border-b border-white/10" : ""
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid={TID.nav.logo}
          className="flex items-center gap-3 group"
        >
          <div className="relative w-10 h-10 overflow-hidden rounded-md ring-1 ring-white/10">
            <img
              src={LOGO_URL}
              alt="Digital Création Promo"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex flex-col leading-tight">
            <span className="font-display text-[15px] tracking-tight text-white">
              Digital <span className="text-gold-gradient">Création</span>
            </span>
            <span className="text-[10px] uppercase tracking-[0.35em] text-white/45">
              Promo · CI
            </span>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.tid}
              className="text-sm text-white/70 hover:text-white transition-colors relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-[#d4af37] group-hover:w-full transition-[width] duration-500" />
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid={TID.nav.ctaOrder}
          className="hidden md:inline-flex btn-gold text-sm px-5 py-2.5 rounded-full items-center gap-2"
        >
          Commander
          <span className="inline-block">→</span>
        </a>

        <button
          className="md:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="md:hidden bg-black/95 border-t border-white/10 px-6 py-6 flex flex-col gap-5"
          >
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-white/80 text-lg"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="btn-gold px-5 py-3 rounded-full text-center"
            >
              Commander
            </a>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
